import React, { useContext } from "react";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { ThemeContext } from "../context/ThemeContext";
import ThemeToggle from "./ThemeToggle";
import { FaHome, FaSignOutAlt } from "react-icons/fa";

const AppLayout = ({ children, signOut, isAuthenticated }) => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  const bgColor = isDark ? "#121212" : "#f8f9fa";
  const textColor = isDark ? "text-light" : "text-dark";
  const borderColor = isDark ? "#333" : "#dee2e6";

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        backgroundColor: bgColor,
        color: isDark ? "#f1f1f1" : "#000",
        transition: "all 0.3s ease",
      }}
    >
      {/* Header */}
      <Navbar
        expand="lg"
        className="sticky-top shadow-sm"
        variant={isDark ? "dark" : "light"}
        style={{
          backgroundColor: isDark ? "#1f1f1f" : bgColor,
          transition: "all 0.3s ease",
        }}
      >
        <Container>
          <Navbar.Brand
            href="/"
            className="fw-bold fs-4 d-flex align-items-center gap-2"
          >
            <img
              src="/logo.png"
              alt="iShare Logo"
              width="36"
              height="36"
              className="d-inline-block align-top"
              style={{ objectFit: "contain" }}
            />
            <span>iShare</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-theme-toggle" />
          <Navbar.Collapse id="navbar-theme-toggle">
            <Nav className="ms-auto align-items-center gap-2">
              {isAuthenticated && (
                <LinkContainer to="/">
                  <Nav.Link className="d-flex align-items-center gap-1">
                    <FaHome size={20} /> 
                  </Nav.Link>
                </LinkContainer>
              )}
              <ThemeToggle isDark={isDark} toggleTheme={toggleTheme} />
              {isAuthenticated && (
                <Button
                  className="ms-2 d-flex align-items-center gap-1"
                  variant="outline-danger"
                  onClick={signOut}
                >
                  <FaSignOutAlt /> Sign out
                </Button>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Content */}
      <Container
        as="main"
        className={`flex-grow-1 d-flex justify-content-center align-items-center py-5 ${textColor}`}
        style={{ minHeight: "70vh", transition: "all 0.3s" }}
      >
        {children}
      </Container>

      {/* Footer */}
      <footer
        className={`text-center mt-auto py-3 ${textColor}`}
        style={{ borderTop: `1px solid ${borderColor}` }}
      >
        &copy; {new Date().getFullYear()} iShare. All rights reserved.
      </footer>
    </div>
  );
};

export default AppLayout;
